import { createFileRoute } from "@tanstack/react-router"

import { SettingsPanel } from "@/pages/SettingsPanel"

export const Route = createFileRoute("/settings")({
  component: SettingsPanel,
})
